module.exports = (__parcel__import__("2BZhr")).then(() => parcelRequire('lkF08'));